export interface BetType {
    id: string;
    name: string;
}

export const BET_TYPES: BetType[] = [
    { id: 'EW', name: 'Each Way' },
    { id: 'RAB', name: 'RAB' },
    { id: 'BB', name: 'BB' },
    { id: 'SGL', name: 'Single' },
    { id: 'SGLBG', name: 'Single - BG' },
    { id: 'TTW', name: 'Tote Win' },
    { id: 'TTP', name: 'Tote Place' },
    { id: 'DBL', name: 'Double' },
    { id: 'FC', name: 'Forecast' },
    { id: 'RFC', name: 'Reverse Forecast' },
    { id: 'SSA', name: 'Single Stakes About' },
    { id: 'TTE', name: 'Exacta' },
    { id: 'TTRE', name: 'Reverse Exacta' },
    { id: 'TBL', name: 'Treble' },
    { id: '2F3', name: 'Doubles from 3' },
    { id: 'TRX', name: 'Trixie' },
    { id: 'PAT', name: 'Patent' },
    { id: 'RR', name: 'Round Robin' },
    { id: 'TC', name: 'Tricast' },
    { id: 'CFC', name: 'Combination Forecast' },
    { id: 'CTC', name: 'Combination Tricast' },
    { id: 'TTT', name: 'Trifecta' },
    { id: 'TTCE', name: 'Combination Exacta' },
    { id: 'TTCT', name: 'Combination Trifecta' },
    { id: '4F', name: '4 fold' },
    { id: '2F4', name: 'Doubles from 4' },
    { id: '3F4', name: 'Trebles from 4' },
    { id: 'YAN', name: 'Yankee' },
    { id: 'L15', name: 'Lucky 15' },
    { id: 'FLG', name: 'Flag' },
    { id: 'TTQ', name: 'Quadpot' },
    { id: '5F', name: '5 fold' },
    { id: '2F5', name: 'Doubles from 5' },
    { id: '3F5', name: 'Trebles from 5' },
    { id: '4F5', name: '4 folds from 5' },
    { id: 'CAN', name: 'Canadian' },
    { id: 'L31', name: 'Lucky 31' },
    { id: 'SFLG', name: 'Super Flag' },
    { id: '6F', name: '6 fold' },
    { id: '2F6', name: 'Doubles from 6' },
    { id: '3F6', name: 'Trebles from 6' },
    { id: '4F6', name: '4 folds from 6' },
    { id: '5F6', name: '5 folds from 6' },
    { id: 'HNZ', name: 'Heinz' },
    { id: 'L63', name: 'Lucky 63' },
    { id: 'TTPP', name: 'Placepot' },
    { id: 'TTJP', name: 'Jackpot' },
    { id: 'TTS6', name: 'Scoop 6' },
    { id: '7F', name: '7 fold' },
    { id: '2F7', name: 'Doubles from 7' },
    { id: '3F7', name: 'Trebles from 7' },
    { id: '4F7', name: '4 folds from 7' },
    { id: '5F7', name: '5 folds from 7' },
    { id: '6F7', name: '6 folds from 7' },
    { id: 'SHNZ', name: 'Super Heinz' },
    { id: '8F', name: '8 fold' },
    { id: '2F8', name: 'Doubles from 8' },
    { id: '3F8', name: 'Trebles from 8' },
    { id: '4F8', name: '4 folds from 8' },
    { id: '5F8', name: '5 folds from 8' },
    { id: '6F8', name: '6 folds from 8' },
    { id: '7F8', name: '7 folds from 8' },
    { id: 'GOL', name: 'Goliath' },
    { id: '9F', name: '9 fold' },
    { id: '2F9', name: 'Doubles from 9' },
    { id: '3F9', name: 'Trebles from 9' },
    { id: '8F9', name: '8 folds from 9' },
    { id: '10F', name: '10 fold' },
    { id: '2F10', name: 'Doubles from 10' },
    { id: '3F10', name: 'Trebles from 10' },
    { id: '9F10', name: '9 folds from 10' },
    { id: '11F', name: '11 fold' },
    { id: '2F11', name: 'Doubles from 11' },
    { id: '3F11', name: 'Trebles from 11' },
    { id: '10F11', name: '10 folds from 11' },
    { id: '12F', name: '12 fold' },
    { id: '2F12', name: 'Doubles from 12' },
    { id: '3F12', name: 'Trebles from 12' },
    { id: '11F12', name: '11 folds from 12' },
    { id: '13F', name: '13 fold' },
    { id: '2F13', name: 'Doubles from 13' },
    { id: '3F13', name: 'Trebles from 13' },
    { id: '12F13', name: '12 folds from 13' },
    { id: '14F', name: '14 fold' },
    { id: '2F14', name: 'Doubles from 14' },
    { id: '3F14', name: 'Trebles from 14' },
    { id: '13F14', name: '13 folds from 14' },
    { id: '15F', name: '15 fold' },
    { id: '2F15', name: 'Doubles from 15' },
    { id: '3F15', name: 'Trebles from 15' },
    { id: '14F15', name: '14 folds from 15' },
    { id: '16F', name: '16 fold' },
    { id: '2F16', name: 'Doubles from 16' },
    { id: '3F16', name: 'Trebles from 16' },
    { id: '15F16', name: '15 folds from 16' },
    { id: '17F', name: '17 fold' },
    { id: '2F17', name: 'Doubles from 17' },
    { id: '3F17', name: 'Trebles from 17' },
    { id: '16F17', name: '16 folds from 17' },
    { id: '18F', name: '18 fold' },
    { id: '2F18', name: 'Doubles from 18' },
    { id: '3F18', name: 'Trebles from 18' },
    { id: '17F18', name: '17 folds from 18' },
    { id: '19F', name: '19 fold' },
    { id: '2F19', name: 'Doubles from 19' },
    { id: '3F19', name: 'Trebles from 19' },
    { id: '18F19', name: '18 folds from 19' },
    { id: '20F', name: '20 fold' },
    { id: '2F20', name: 'Doubles from 20' },
    { id: '3F20', name: 'Trebles from 20' },
    { id: '19F20', name: '19 folds from 20' },
    { id: '21F', name: '21 fold' },
    { id: '2F21', name: 'Doubles from 21' },
    { id: '3F21', name: 'Trebles from 21' },
    { id: '20F21', name: '20 folds from 21' },
    { id: '22F', name: '22 fold' },
    { id: '2F22', name: 'Doubles from 22' },
    { id: '3F22', name: 'Trebles from 22' },
    { id: '21F22', name: '21 folds from 22' },
    { id: '23F', name: '23 fold' },
    { id: '2F23', name: 'Doubles from 23' },
    { id: '3F23', name: 'Trebles from 23' },
    { id: '22F23', name: '22 folds from 23' },
    { id: '24F', name: '24 fold' },
    { id: '2F24', name: 'Doubles from 24' },
    { id: '3F24', name: 'Trebles from 24' },
    { id: '23F24', name: '23 folds from 24' },
    { id: '25F', name: '25 fold' },
    { id: '2F25', name: 'Doubles from 25' },
    { id: '3F25', name: 'Trebles from 25' },
    { id: '24F25', name: '24 folds from 25' },
];
